export default "__VITE_ASSET__CHk$fT89__"